import {ChangeDetectionStrategy, Component, HostBinding, inject, Input, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';

import {StoryblokDirective} from '@core/directives/storyblok.directive';
import {DynamicModule} from 'ng-dynamic-component';
import {NgComponentOutlet} from '@angular/common';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {StoryblokDynamicInputService} from '@core/services/storyblok-dynamic-input.service';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';
import {StoryblokReadMoreComponent} from '@modules/storyblok/components/storyblok-read-more.component';

@Component({
  selector: 'app-storyblok-container',
  templateUrl: './storyblok-container.component.html',
  styleUrls: ['./storyblok-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicModule, NgComponentOutlet, ReadMoreComponent]
})
export class StoryblokContainerComponent extends StoryblokReadMoreComponent implements OnInit {
  protected storyblokComponentService = inject(StoryblokComponentService);
  private storyblokStylingService = inject(StoryblokStylingService);
  private storyblokDynamicInputService = inject(StoryblokDynamicInputService);

  components: any = this.storyblokComponentService.getComponents();

  background_color = input<string>();

  general_styling = input<any>();
  body = input<any[]>();
  _editable = input<any>();

  @Input()
  set elementId(value: any) {
    this.hostElementId = value;
  }

  constructor() {
    super();
  }

  @HostBinding('attr.id') hostElementId: any;
  @HostBinding('class') class: any;

  @HostBinding('style.background-color')
  get backgroundColor() {
    return this.storyblokDynamicInputService.replaceDynamicInputs(this.background_color() ?? '', true)();
  };

  ngOnInit() {
    this.class = this.storyblokStylingService.getClassList(this.general_styling());
  }

}
